import { Row } from 'antd';

import PhotoReel from '../common/photos/PhotoReel';

import { parseDateField, timestampsToText } from '../boards/boards.helpers';

export default (field = {}) => {
  const {
    selectedType: fieldType,
    configProps = {},
    response,
    onFileClick,
  } = field;
  switch (fieldType) {
    case 'text':
    case 'calculation':
      return response.value ?? '';
    case 'dropdown': {
      const { values = [] } = response;
      return values.map((val) => val.name).join(', ');
    }
    case 'yes-no':
      const { value, explanation } = response;
      let ans = null;
      // value === undefined if user didnt fill out the field
      if (value === true) {
        ans = 'Yes';
      } else if (value === false) {
        ans = 'No';
      }
      if (explanation) ans += `. ${explanation}`;
      return ans;
    case 'dateRange': return timestampsToText(response);
    case 'dateTime': return parseDateField(response, configProps);
    case 'attachment':
      const { files = [] } = response;
      return (
        <Row style={{ width: '100vw' }}>
          <PhotoReel
            small
            files={files}
            onClick={(idx) => {
              if(idx < files.length) {
                onFileClick(files[idx])
              }
            }}
          />
        </Row>
      );
    default:
      return null;
  }
}

